export default function transformRateSummary(summary) {
  const ratesCount = [0, 0, 0, 0, 0];
  for (let i = 1; i <= 5; i++) {
    ratesCount[i - 1] = summary[`r${i}_count`];
  }

  return {
    ratesCount,
    totalCount: summary.total_count,
    rate: summary.rate,
  };
}
